
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, PlusCircle } from "lucide-react";
import { AgentConfiguration } from "@/components/candidates/types/agent";

type AgentListProps = {
  configurations: AgentConfiguration[];
  selectedAgentId: string;
  onAgentChange: (agentId: string) => void;
  onCreateAgent: () => void;
};

export const AgentList = ({
  configurations,
  selectedAgentId,
  onAgentChange,
  onCreateAgent
}: AgentListProps) => {
  return (
    <Card className="md:col-span-1">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            <span>AI Agents</span>
          </CardTitle>
          <Button
            variant="outline"
            size="sm"
            onClick={onCreateAgent}
            className="flex items-center gap-1"
          >
            <PlusCircle className="h-4 w-4" />
            New Agent
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-3">
        <div className="space-y-2">
          {configurations.map(config => (
            <Button
              key={config.id}
              variant={selectedAgentId === config.id ? "default" : "outline"}
              className="w-full justify-start text-left h-auto py-3"
              onClick={() => onAgentChange(config.id)}
            >
              <div className="flex items-center gap-3">
                <div className={`w-2 h-2 rounded-full ${config.isEnabled ? 'bg-green-500' : 'bg-gray-300'}`} />
                <div>
                  <div className="font-medium">{config.name}</div>
                  <div className="text-xs text-muted-foreground truncate max-w-[180px]">
                    {config.description}
                  </div>
                </div>
              </div>
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
